'use strict';

import { Clock } from 'three';

export class Loop {
    constructor (scope) {
        this.camera = scope.camera;
        this.scene = scope.scene;
        this.renderer = scope.renderer;
        this.updatables = [];
        this.clock = new Clock();
    }

    start() {
        this.renderer.setAnimationLoop(() => {
            this.tick();
            this.renderer.render(this.scene,this.camera);
        });
    }

    tick() {
        this.updatables.forEach(element => {
            const delta = this.clock.getDelta();
            element.tick(delta);
        })
    }

    stop() {
        this.renderer.setAnimationLoop(null);
    }

    add(el) {
        this.updatables.push(el);
    }

    remove(el) {
        this.updatables = this.updatables.filter(loop => loop !== el);
    }

}
